import React from 'react';
import { useParams } from 'react-router-dom';
import PublicQuoteForm from '../components/public/PublicQuoteForm';

// ============================================================================
// PUBLIC QUOTE PAGE - Hosted at /request-quote/:slug
// This is the customer-facing page for lead capture
// ============================================================================

const PublicQuotePage = () => {
  const { slug } = useParams();

  const handleSuccess = (data) => {
    // Optional: Track conversion in analytics
    if (window.gtag) {
      window.gtag('event', 'lead_submission', {
        event_category: 'Lead',
        event_label: slug,
        value: data.quoteRange?.high || 0
      });
    }
    
    // Optional: Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: slug,
        value: data.quoteRange?.high || 0,
        currency: 'USD'
      });
    }
  };

  return (
    <PublicQuoteForm 
      slug={slug} 
      onSuccess={handleSuccess}
    />
  );
};

export default PublicQuotePage;